import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id C2F3461E-363D-42B9-AEF0-3E8A92EB2569
 * name compare-horizontal
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/compare-horizontal.svg
 * tags
 * - Arrow 
 */
export const CompareHorizontalIcon = createSvgIcon(<><path d="M9 14H2V16H9V19L13 15L9 11V14M15 13V10H22V8H15V5L11 9L15 13Z" /></>, 'CompareHorizontalIcon');
export default CompareHorizontalIcon